import { Component, OnInit, EventEmitter, Input, Output } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { Proforma } from '../../../models/proforma';
import { ProformaService } from '../../../services/proforma.service';
import { Pagination } from '../../../models/pagination';

@Component({
  selector: 'app-proforma-modal',
  templateUrl: './proforma-modal.component.html',
  styleUrls: ['./proforma-modal.component.css'],
  providers: [
    ProformaService
  ]
})
export class ProformaModalComponent implements OnInit {

	@Output() sendProforma = new EventEmitter();	
	@Input() numero_decimales: number = 2;
	public title: String;
	public proformas: Array<Proforma> = [];
	public selectedRow: number;
	private proforma;
	public pagination: Pagination;
	public loading = false;
	public format_decimal: String;

	constructor(
		public proformaService: ProformaService,
		public bsModalRef: BsModalRef
	) { 
		this.title = "Proforma";
		this.pagination = new Pagination();
		this.format_decimal = "0,0.00";
	}

	ngOnInit() {
		let digitos = "";
		for(let i = 0; i < this.numero_decimales; i++) digitos += "0";
		this.format_decimal = "0,0." + digitos

		this.getProformas();
	}

	getProformasBySearch(text){
		let qs = "&q[proforma.secuencial]=" + text + "&q[cliente.razon_social]=" + text + "&q[cliente.nombre_comercial]=" + text;
		this.pagination.current_page = 1;
		this.getProformas(qs);
	}

	getProformas(qs = ""){
		this.loading = true;
		this.proformaService.getModalProforma('?page='+this.pagination.current_page+'&per_page=10' + qs).subscribe(
			res =>{
			this.proformas = res.data;
					this.loading = false;
					
					this.pagination.current_page = res.current_page;
					this.pagination.from = res.from;
					this.pagination.to = res.to;
					this.pagination.total = res.total;
					this.pagination.last_page = res.last_page;
					this.pagination.next_disabled = (this.pagination.current_page === this.pagination.last_page);
					this.pagination.prev_disabled = this.pagination.current_page === 1;
			},
			err =>{
			this.proformas = [];
			this.loading = false;
			}
		);
	}

	onSelectRow(proforma, i) {
		this.selectedRow = i;		
		this.proforma = proforma;
	}

	onDBLClick(proforma, i) {
		this.onSelectRow(proforma, i);
		this.onSubmit();
	}

	onSubmit() {
		this.sendProforma.emit(this.proforma);			
		this.bsModalRef.hide();
	}

	next(){
		this.pagination.current_page++;
		this.getProformas();
	}

	prev(){
		this.pagination.current_page--;
		this.getProformas();
	}

	first(){
		this.pagination.current_page = 1;
		this.getProformas();
	}

	last(){
		this.pagination.current_page = this.pagination.last_page;
		this.getProformas();
	}

	get formatDecimal(){
        return this.format_decimal;
    }

}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/components/modals/proforma-modal/proforma-modal.component.ts